import RegistrationsArchiveService from "@/services/RegistrationsArchiveService";
import { formatDate, unformatDate } from "@/utils/dates";

const getDefaultState = () => {
    return {
        archive: {
            data: [],
            from: new Date(new Date() - 604800000)
                .toISOString()
                .substring(0, 10),
            to: new Date().toISOString().substring(0, 10),
            defaultFrom: new Date(new Date() - 604800000) // 1 week
                .toISOString()
                .substring(0, 10),
            defaultTo: new Date().toISOString().substring(0, 10),
        },
    };
};

export default {
    state: () => getDefaultState(),
    mutations: {
        setArchive: (state, archive) => {
            state.archive.data = archive;
            for (const elem of state.archive.data) {
                const dateTime = elem.updated_at.split(" ");
                elem.intDate = new Date(
                    formatDate(elem.arrival_date_from)
                ).getTime();
                elem.intUpdatedAt = new Date(
                    `${unformatDate(dateTime[0])}T${dateTime[1]}`
                ).getTime();
            }
        },
        setArchiveState: state => {
            Object.assign(state, getDefaultState());
        },
    },
    getters: {
        getArchive: state => state.archive.data,
        isArchiveDateFromDefault: state =>
            state.archive.from === state.archive.defaultFrom,
        isArchiveDateToDefault: state =>
            state.archive.to === state.archive.defaultTo,
    },
    actions: {
        processArchive: async ({ state, dispatch, commit }) => {
            try {
                commit("setLoading", true);
                const response = await RegistrationsArchiveService.getByDate(
                    formatDate(state.archive.from),
                    formatDate(state.archive.to)
                );
                commit("setArchive", response.data.data);
            } catch (e) {
                if (e.response.data.message === "Objects were not found") {
                    commit("setArchive", []);
                } else {
                    dispatch("generalErrorHandling", e);
                }
            } finally {
                commit("setLoading", false);
            }
        },

        undoArchive: async ({ dispatch, commit }, id) => {
            try {
                commit("setLoading", true);
                await RegistrationsArchiveService.undo(id);
                await dispatch("processArchive");
                commit({
                    type: "alert",
                    text: "UNDO Successful",
                    color: "",
                    icon: "check_circle",
                });
            } catch (e) {
                dispatch("generalErrorHandling", e);
            } finally {
                commit("setLoading", false);
            }
        },

        resetRegistrationsArchiveState: ({ commit }) => {
            commit("setArchiveState");
        },
    },
};
